import { LearnizMedia } from '../media';
import { GameData } from '../../games/data';
import { ProductError, ProductErrorType } from '../../models';

export class GameOptions {
  neutralSentence?: string;
  victorySentence?: string;
  failSentence?: string;
  showAnswer: boolean;
  showScore: boolean;
  showTrophy: boolean;
  canReplay: boolean;

  constructor(options?: GameOptions) {
    this.neutralSentence = options?.neutralSentence;
    this.victorySentence = options?.victorySentence;
    this.failSentence = options?.failSentence;
    this.showAnswer = options?.showAnswer ?? true;
    this.showScore = options?.showScore ?? true;
    this.showTrophy = options?.showTrophy ?? true;
    this.canReplay = options?.canReplay ?? true;
  }

  static validate(data: GameOptions, medias: LearnizMedia<GameData>[], payloadData: any): ProductError[] {
    // for now data doesn't need validation all properties are optional
    if (!medias || !medias.length) {
      return [{ type: ProductErrorType.MISSING, property: 'medias', payload: { ...payloadData } }];
    } else if (medias.length > 1) {
      return [{ type: ProductErrorType.TOO_MUCH_VALUES, property: 'medias', payload: { ...payloadData } }];
    }
    return LearnizMedia.validate(medias[0], payloadData);
  }
}
